var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDropBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06641 0C7.37454 0.000115189 10.0077 1.73652 10.0078 5.04688C10.0078 7.2492 8.36278 9.5718 5.06641 12C1.76994 9.57176 0.125 7.24923 0.125 5.04688C0.125098 1.73641 2.75821 0 5.06641 0ZM5.06641 1.41113C3.70405 1.41113 1.53613 2.39982 1.53613 5.04688C1.5362 6.5645 2.75117 8.34333 5.06641 10.2139C7.38148 8.3434 8.59564 6.5715 8.5957 5.04688C8.5957 2.40011 6.42879 1.41135 5.06641 1.41113ZM5.06641 3.52832C5.84598 3.52846 6.47754 4.16082 6.47754 4.94043C6.47753 5.72003 5.84598 6.3524 5.06641 6.35254C4.28994 6.35254 3.65431 5.71689 3.6543 4.94043C3.6543 4.16396 4.28994 3.52832 5.06641 3.52832Z",
    fill: "#87928D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDropBlack);
export default __webpack_public_path__ + "static/media/pin_drop_black.017c18a9ec585dbe724f4dca55223e37.svg";
export { ForwardRef as ReactComponent };